module.exports = __webpack_public_path__ + "node_modules/icheck/skins/minimal/green.png?3b4856d9";